<template>
  <data-grid-remote
    :server-url="getEndpointUrl"
    :total-rows="getTotalRows"
    :fetch-instance="fetchInstance"
    :sort="[{ dataId: initialSort.dataId, direction: initialSort.direction }]"
    :page-size="initialPageSize"
  >
    <data-grid-column 
      :data-id="gridColumns.data[0].dataId" 
      :title="gridColumns.data[0].columnHeading" 
      sort="desc" 
      :sortable="isSortable(gridColumns.data[0].sortable)" 
    />
    <data-grid-column 
      :data-id="gridColumns.data[1].dataId" 
      :title="gridColumns.data[1].columnHeading" 
      sort="desc" 
      :sortable="isSortable(gridColumns.data[1].sortable)"
    />
    <data-grid-column 
      :data-id="gridColumns.data[2].dataId" 
      :title="gridColumns.data[2].columnHeading" 
      sort="desc" 
      :sortable="isSortable(gridColumns.data[2].sortable)" 
    />
    <data-grid-column 
      v-slot="value" 
      :data-id="gridColumns.data[3].dataId" 
      :title="gridColumns.data[3].columnHeading" 
      :sortable="isSortable(gridColumns.data[3].sortable)"
    >
      <f-button 
        text="View" 
        tag="link" 
        :href="value" 
        type="secondary" 
        size="small" 
      />
    </data-grid-column>
  </data-grid-remote>
</template>

<script>
import { computed, defineComponent, ref, watch } from "vue";
import { createFetch } from "@vueuse/core";
export default defineComponent({
  name: "RemoteDataTable",
  props:{
    endpointUrl:{
      required: true,
      type: String
    },
    columns:{
      required: true,
      type: Object
    },
    initialSort:{
      type: Object,
      default: () => ({ dataId: "", direction: "" }),
    },
    initialPageSize:{
      type: Number,
      default: 10
    }
  },
  setup(props) {
    const execute = ref();
    const fetchInstance = createFetch();
    const gridColumns = ref(props.columns);
    const isTypeChanged = ref(false);


    watch(() => props.columns, (value) => {
      gridColumns.value = value;
      isTypeChanged.value = true;
    });

    const getTotalRows = (payload) => {
      return payload.data?.[0]?.totalRows > 0 ? payload.data[0].totalRows : 0;
    };

    const getEndpointUrl = computed(() => {
      const gridColumnsValue = gridColumns.value;
      return ({itemsPerPage, pageNumber, sort})=>{
        const params = new URLSearchParams();
        const primarySort = sort.at(-1); // Last sort element

        params.append("type", `${gridColumnsValue.type}`);
        params.append("limit", `${itemsPerPage}`);

        if(isTypeChanged.value){
          params.append("page", 1);
          pageNumber = 1;
        }else{
          params.append("page", `${pageNumber}`);
        }

        if (primarySort) {
          params.append("order_by", primarySort.dataId);
          params.append("order", primarySort.direction);
        }

        isTypeChanged.value = false;
        return `${props.endpointUrl}?${params.toString()}`;
      };
    });

    const isSortable = (value) => {
      return value;
    };
    
    return {
      execute,
      fetchInstance,
      getTotalRows,
      getEndpointUrl,
      gridColumns,
      isSortable
    };
  },
});
</script>

